<template>
	<div class="projetolistagem">
		<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0"
			objectbg="#0d0c0d" opacity="50" name="circular"></loader>
		<div class="container-fluid">
			<ol class="breadcrumb-arrow">
				<li>
					<a href="/home"><i class="fa fa-home"></i></a>
					<a href="/projeto-listagem">Projetos</a>
				</li>
			</ol>
		</div>

		<div class="container-fluid mt-2">
			<div class="container-fluid mt-2">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-6 text-left">
								<a class="btn btn-light" data-toggle="collapse" href="#collapseFiltro" role="button" tabindex="1"
									aria-expanded="true" aria-controls="collapseFiltro">
									<i class="text-muted fas fa-stream mr-2"></i>
									Filtro
								</a>
							</div>
							<div class="col-6 text-right">

								<div class="col-lg-12 col-sm-12 text-right">
									<el-tooltip content="Incluir projeto" placement="top">
										<span>
											<button type="button" tabindex="2" class="btn btn-info"
												@click="incluirProjeto()">
												<i class="fa fa-plus mr-2"></i>
												<span>Incluir</span>
											</button>
										</span>
									</el-tooltip>
								</div>

							</div>
						</div>

						<div class="collapse" id="collapseFiltro">
							<div class="font-13 pt-2">

								<div class="mt-2 row border rounded-top font-weight-bold">
									<div class="text-center col-6 filtro-contexto-ativo">
										Projeto
									</div>
									<div class="text-center col-6 filtro-contexto-inativo">
										Atividade
									</div>
								</div>
								<div class="row">

									<!-- div Projeto -->
									<div class="col-6 py-1 filtro-contexto-ativo-corpo">
										<div class="form-check">
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoNI" id="sitProjetoCheck1" tabindex="3">
													<label class="form-check-label" for="sitProjetoCheck1">
														Não Iniciado
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoEA" id="sitProjetoCheck2" tabindex="4">
													<label class="form-check-label" for="sitProjetoCheck2">
														Em Andamento
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoVA" id="sitProjetoCheck8" tabindex="5">
													<label class="form-check-label" for="sitProjetoCheck8">
														Aguardando Validação
													</label>
												</div>
											</div>
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoCA" id="sitProjetoCheck7" tabindex="6">
													<label class="form-check-label" for="sitProjetoCheck7">
														Cancelado
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoCO" id="sitProjetoCheck3" tabindex="7">
													<label class="form-check-label" for="sitProjetoCheck3">
														Concluído
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoRE" id="sitProjetoCheck5" tabindex="8">
													<label class="form-check-label" for="sitProjetoCheck5">
														Rejeitado
													</label>
												</div>
											</div>
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoAT" id="sitProjetoCheck4" tabindex="9">
													<label class="form-check-label" for="sitProjetoCheck4">
														Atrasado
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetoReagendado" id="sitProjetoCheck9" tabindex="10">
													<label class="form-check-label" for="sitProjetoCheck9">
														Reagendado
													</label>
												</div>
											</div>
										</div>
										<div class="mt-2 row font-weight-bold">
											<div class="col">
												<div class="ml-2">Data Inicial</div>
												<flat-picker tabindex="11" id="projetoDataInicio" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data Inicial"
													v-model="filtro.projetoDataInicio" :config="configData"
													@blur.native="validarCampoData('projetoDataInicio', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
											<div class="col">
												<div class="ml-2">Data Final</div>
												<flat-picker tabindex="12" id="projetoDataFim"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data Final" autocomplete="off"
													v-model="filtro.projetoDataFim" :config="configData"
													@blur.native="validarCampoData('projetoDataFim', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
											<div class="col">
												<div class="ml-2">Data de Conclusão</div>
												<flat-picker tabindex="13" id="projetoDataConclusao" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data de Conclusão"
													v-model="filtro.projetoDataConclusao" :config="configData"
													@blur.native="validarCampoData('projetoDataConclusao', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col">
												<div class="ml-2 font-weight-bold">Projeto criado por</div>
												<v-select class="mb-2" placeholder="Selecione Usuário" label="nome" multiple :tabindex="14"
													:reduce="(u) => u.idusuario" v-model="filtro.projetocriador"
													:options="listaUsuarios">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Responsável</div>
												<v-select class="mb-2" placeholder="Selecione Responsável" label="nome" :tabindex="15"
													multiple :reduce="(u) => u.idusuario"
													v-model="filtro.projetoresponsavel" :options="listaUsuarios">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col">
												<div class="ml-2 font-weight-bold">Classificação</div>
												<v-select class="mb-2" placeholder="Selecione a Classificação" :tabindex="16"
													label="descricao" multiple :reduce="(c) => c.codigo"
													v-model="filtro.classificacao" :options="listaClassificacao">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Relevância</div>
												<v-select class="mb-2" placeholder="Selecione a Relevância" :tabindex="17"
													label="descricao" multiple :reduce="(c) => c.codigo"
													v-model="filtro.relevancia" :options="listaRelevancia">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Grupo de Trabalho</div>
												<v-select class="mb-2" placeholder="Selecione o Grupo" label="nomeComCoord" :tabindex="18"
													multiple :reduce="(c) => c.idgt" v-model="filtro.grupoTrabalho"
													:options="listaGT">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
										</div>
									</div>
									<!-- div Atividade -->
									<div class="col-6 py-1 filtro-contexto-inativo-corpo">
										<div class="form-check">
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoNI" id="sitAtividadeCheck1" tabindex="19">
													<label class="form-check-label" for="sitAtividadeCheck1">
														Não Iniciada
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoEA" id="sitAtividadeCheck2" tabindex="20">
													<label class="form-check-label" for="sitAtividadeCheck2">
														Em Andamento
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadedestaque" id="atividadedestaque" tabindex="21">
													<label class="form-check-label" for="atividadedestaque">
														Destaque
													</label>
												</div>
											</div>
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoCA" id="sitAtividadeCheck6" tabindex="22">
													<label class="form-check-label" for="sitAtividadeCheck6">
														Cancelada
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoCO" id="sitAtividadeCheck3" tabindex="23">
													<label class="form-check-label" for="sitAtividadeCheck3">
														Concluída
													</label>
												</div>
											</div>
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoAT" id="sitAtividadeCheck4" tabindex="24">
													<label class="form-check-label" for="sitAtividadeCheck4">
														Atrasada
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadeReagendada" id="atividadeRA" tabindex="25">
													<label class="form-check-label" for="atividadeRA">
														Reagendada
													</label>
												</div>
											</div>
										</div>
										<div class="mt-2 row font-weight-bold">
											<div class="col">
												<div class="ml-2">Data Inicial</div>
												<flat-picker tabindex="26" id="atividadeDataInicio" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data Inicial"
													v-model="filtro.atividadeDataInicio" :config="configData"
													@blur.native="validarCampoData('atividadeDataInicio', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
											<div class="col">
												<div class="ml-2">Data Final</div>
												<flat-picker tabindex="27" id="atividadeDataFim" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data Final"
													v-model="filtro.atividadeDataFim" :config="configData"
													@blur.native="validarCampoData('atividadeDataFim', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
											<div class="col">
												<div class="ml-2">Data de Conclusão</div>
												<flat-picker tabindex="28" id="atividadeDataConclusao" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data de Conclusão"
													v-model="filtro.atividadeDataConclusao" :config="configData"
													@blur.native="validarCampoData('atividadeDataConclusao', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col">
												<div class="ml-2 font-weight-bold">Atividade criada por</div>
												<v-select class="mb-2" placeholder="Selecione Usuário" label="nome" multiple :tabindex="29"
													:reduce="(u) => u.idusuario" v-model="filtro.atividadecriador"
													:options="listaUsuarios">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Responsável</div>
												<v-select class="mb-2" placeholder="Selecione Responsável" label="nome" :tabindex="30"
													multiple :reduce="(u) => u.idusuario"
													v-model="filtro.atividaderesponsavel" :options="listaUsuarios">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col">
												<div class="ml-2 font-weight-bold">Investimento</div>
												<v-select class="mb-2" placeholder="Selecione o Investimento" :tabindex="31"
													label="descricao" :reduce="(c) => c.codigo"
													v-model="filtro.investimento" :options="listaInvestimento">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Tipo de Atividade</div>
												<v-select class="mb-2" placeholder="Selecione o Tipo de Atividade" :tabindex="32"
													label="nome" multiple :reduce="(c) => c.idsubtipoatividade"
													v-model="filtro.tipoAtividade" :options="listaTipoAtividade">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Grupo de Trabalho</div>
												<v-select class="mb-2" placeholder="Selecione o Grupo" label="nomeComCoord" :tabindex="33"
													multiple :reduce="(c) => c.idgt" v-model="filtro.grupoTrabalhoAtividade"
													:options="listaGT">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col mt--2">
												<div class="input-group">
													<div class="input-group-prepend mr-n1" style="height: 30px;">
														<span class="input-group-text pt-2 pb-2"
															style="font-size: 13px !important;">R$</span>
													</div>
													<vue-numeric style="font-size: 13px; height: 30px;" tabindex="34"
														placeholder="Valor de Investimento" class="form-control"
														v-model="filtro.valorInvestimento" separator="."
														v-bind:precision="2" v-bind:minus="false">
													</vue-numeric>
												</div>
											</div>
											<div class="col">
											</div>
											<div class="col">
											</div>
										</div>
										<div class="text-right mr-2 mt--3">
										<a class="btn btn-light" tabindex="35" @click.prevent="limparFiltro">
												<i class="fas fa-eraser mr-2"></i>
												Limpar Filtro
											</a>
										<a class="btn btn-info" tabindex="36" @click.prevent="filtrarProjeto">
												<i class="fas fa-filter mr-2"></i>
												Aplicar
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-fluid mt-2">
			<div class="container-fluid mt-2">
				<div class="card">
					<div class="card-body">
						<div class="row ml-0 mr-0 page-header-title">
							<div class="col-lg-10 col-sm-6 pr-0 pl-0 d-none d-sm-block d-lg-block d-xl-block">
								<h2 class="text-header txt-bloqueio">Projetos {{ (sortedProjetos.length > 0) ? "(" +
									sortedProjetos.length + ")" : "" }}</h2>
							</div>
							<div class="col-lg-2 col-sm-2 nput-search pl-0 nput-group d-flex pr-0">
								<input class="input-pesquisa-imprimir inputiPad search-menu" tabindex="37"
									placeholder="Pesquisar projeto..." v-model="filtroTipo" @keyup="filtrarTipo" />
							</div>
						</div>
						<div id="accordionPendentes">
							<table class="table table-hover">
								<thead style="background-image: linear-gradient(to left, white, #f2f2f2)">
									<tr class="clickable">
										<th class="text-center" @click="sort('nomeCodigo')">Projeto <i
												class="text-muted fas fa-sort mr-2"></i></th>
										<th class="text-center" @click="sort('dataInicio')">Data início <i
												class="text-muted fas fa-sort mr-2"></i></th>
										<th class="text-center" @click="sort('dataFim')">Data fim <i
												class="text-muted fas fa-sort mr-2"></i></th>
										<th class="text-center" @click="sort('situacaoDescricao')">Situação <i
												class="text-muted fas fa-sort mr-2"></i></th>
										<th class="text-center" @click="sort('classificacaoDescricao')">Classificação <i
												class="text-muted fas fa-sort mr-2"></i></th>
										<th style="width: 5% !important"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="projeto in sortedProjetos" :key="projeto.idprojeto">
										<td>
											<strong class="clickable" @click="abrirModalProjeto(projeto)">
												<span class="text-wrap">
													{{ projeto.nomeCodigo }}
												</span>
											</strong>
										</td>
										<td class="text-center" :class="(projeto.reagendado) ? 'font-reagenda' : ''">
											{{ projeto.dataInicio }}
										</td>
										<td class="text-center" :class="(projeto.reagendado) ? 'font-reagenda' : ''">
											{{ projeto.dataFim }}
										</td>

										<td class="text-center">
											{{ projeto.situacaoDescricao }}
											<span :class="'font-' + projeto.situacao"
												v-if="projeto.situacao == 'CONCLUIDO' || projeto.situacao == 'CANCELADO'"><br />(em
												{{ projeto.dataConclusao }})</span>
											<span class="font-atrasado" v-if="projeto.situacao == 'ATRASADO'"><br />({{
												projeto.atraso }})</span>
											<el-tooltip :content="projeto.progresso + '%'" placement="top"
												v-if="projeto.situacao == 'EMANDAMENTO'">
												<div class="progress mt-1">
													<div class="progress-bar" role="progressbar"
														:style="'font-size: 11px; width: ' + projeto.progresso + '%;'"
														:class="'progresso-' + projeto.situacao">
													</div>
												</div>
											</el-tooltip>
										</td>
										<td class="text-center">
											{{ projeto.classificacaoDescricao }}
										</td>
										<td class="text-center" style="width: 5% !important">
											<el-tooltip content="Alterar" placement="top">
												<i @click="alterarProjetoLista(projeto)"
													v-show="projeto.situacao === 'REJEITADO' 
														|| perfilAdmin || perfilCoordenador"
													class="fas fa-edit ml-3 icones iconeAlterar"></i>
											</el-tooltip>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

			</div>
		</div>

		<modal :show.sync="modals.modalProjeto" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalProjeto()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
			</div>
			<Projeto v-if="modals.modalProjeto" 
				@atualizar-lista="filtrarProjeto" 
				@fechar-projeto="closeModalProjeto"
				@abrir-atividade="abrirModalAtividade" 
				:projetoSelecionado=projetoModal />
		</modal>

		<modal id="modalAtividade" :show.sync="modals.modalAtividade" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalAtividade()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
			</div>
			<Atividade v-if="modals.modalAtividade" 
				@fechar-atividade="closeModalAtividade"
				@abrir-projeto="abrirModalProjeto" 
				:atividadeSelecionada=atividadeModal />
		</modal>

		<modal id="modalEdicaoProjeto" :show.sync="modals.modalEdicaoProjeto" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalEdicaoProjeto()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
			</div>
			<ProjetoFormulario v-if="modals.modalEdicaoProjeto"
				@cancel="closeModalEdicaoProjeto"
				@save="salvarProjetoEdicao"
				:idprojeto="projetoEdicao && projetoEdicao.idprojeto ? projetoEdicao.idprojeto : null" />
		</modal>

	</div>
</template>

<script>
const customLabels = {
	first: "<<",
	last: ">>",
	previous: "<",
	next: ">",
};

const defaultStyles = {
	ul: {
		margin: 0,
		padding: 0,
		display: "inline-block",
	},
	li: {
		listStyle: "none",
		display: "inline",
		textAlign: "center",
	},
	a: {
		cursor: "pointer",
		padding: "7px 7px",
		display: "block",
		float: "left",
	},
};

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "vue-select/dist/vue-select.css";
import Projeto from "@/components/Projeto.vue";
import Atividade from "@/components/Atividade.vue";
import ProjetoFormulario from "@/components/ProjetoFormulario.vue";

export default {
	components: {
		Projeto,
		Atividade,
		ProjetoFormulario,
		flatPicker
	},
	created() {
		this.carregarTela();
	},
	data() {
		return {
			pageOfItems: [],
			progress: true,
			listaProjeto: [],
			listaProjetoFiltro: [],
			listaClassificacao: [],
			listaRelevancia: [],
			listaInvestimento: [],
			listaTipoAtividade: [],
			listaGT: [],
			listaUsuarios: [],
			filtroTipo: "",
			configData: {
				allowInput: true,
				clickOpens: true,
				disableMobile: true,
				dateFormat: "d/m/Y",
			},
			filtro: {
				projetosituacaoNI: true,
				projetosituacaoEA: true,
				projetosituacaoVA: true,
				projetosituacaoRE: true,
				projetosituacaoAT: true,
				ordem: 5,
			},
			customLabels,
			defaultStyles,
			projeto: {},
			modals: {
				modalProjeto: false,
				modalAtividade: false,
				modalEdicaoProjeto: false,
			},
			projetoModal: null,
			atividadeModal: null,
			projetoEdicao: null,
			currentSort: 'nomeCodigo',
			currentSortDir: 'asc',
			logsFiltro: [],
			perfilAdmin: false,
			perfilCoordenador: false,
		};
	},
	computed: {
		sortedProjetos: function () {
			try {
				return this.listaProjeto.sort((a, b) => {
				let modifier = 1;
				if (this.currentSortDir === 'desc') modifier = -1;
				const dateA = this.isDate(a[this.currentSort]) ? new Date(this.parseDate(a[this.currentSort])) : a[this.currentSort];
				const dateB = this.isDate(b[this.currentSort]) ? new Date(this.parseDate(b[this.currentSort])) : b[this.currentSort];
				if (dateA < dateB) return -1 * modifier;
				if (dateA > dateB) return 1 * modifier;
				return 0;
			});
			} catch (error) {
				console.log(error)
			}
		}
	},
	methods: {
		dataValida(valor) {
			if (typeof valor !== "string" || !/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
				return false;
			}
			const partes = valor.split("/").map(Number);
			const dia = partes[0];
			const mes = partes[1];
			const ano = partes[2];
			if (ano < 1900) {
				return false;
			}
			const data = new Date(ano, mes - 1, dia);
			return data.getFullYear() === ano
				&& data.getMonth() === mes - 1
				&& data.getDate() === dia;
		},
		validarCampoData(campo, evento) {
			const valor = evento && evento.target ? evento.target.value : this.filtro[campo];
			if (!valor) {
				this.$set(this.filtro, campo, "");
				return true;
			}
			if (this.dataValida(valor)) {
				this.$set(this.filtro, campo, valor);
				return true;
			}
			this.$toastr.warning("Data inválida. Informe uma data válida no formato dd/mm/aaaa.");
			this.$set(this.filtro, campo, "");
			if (evento && evento.target) {
				evento.target.value = "";
			}
			return false;
		},
		converterDataFiltro(valor) {
			const partes = valor.split("/").map(Number);
			return new Date(partes[2], partes[1] - 1, partes[0]);
		},
		validarPeriodoFiltro(campoInicial, campoFinal, entidade) {
			const dataInicial = this.filtro[campoInicial];
			const dataFinal = this.filtro[campoFinal];
			if (!dataInicial || !dataFinal) {
				return true;
			}
			if (this.converterDataFiltro(dataFinal) <= this.converterDataFiltro(dataInicial)) {
				this.$toastr.warning(`A data final ${entidade} deve ser maior que a data inicial.`);
				return false;
			}
			return true;
		},
		validarPeriodosFiltro() {
			return this.validarPeriodoFiltro("projetoDataInicio", "projetoDataFim", "do projeto")
				&& this.validarPeriodoFiltro("atividadeDataInicio", "atividadeDataFim", "da atividade");
		},
		habilitarDigitacaoData(...parametros) {
			const instancia = parametros[2];
			if (instancia && instancia._input) {
				instancia._input.removeAttribute("readonly");
			}
		},
		sort: function (s) {
			if (s === this.currentSort) {
				this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = s;
		},
		parseDate: function (dateString) {
			const [day, month, year] = dateString.split('/');
			return `${year}-${month}-${day}`;
		},
		isDate: function (value) {
			return /^\d{2}\/\d{2}\/\d{4}$/.test(value);
		},
		alterarProjetoLista(projeto) {
			if (projeto.situacao === "REJEITADO" || this.perfilAdmin || this.perfilCoordenador) {
				this.progress = true;
				this.$clubApi.get("/projeto/" + projeto.idprojeto).then((response) => {
					this.projetoEdicao = response.data.object;
					this.modals.modalEdicaoProjeto = true;
				}).catch((error) => {
					this.$toastr.error(error.response.data.msg);
				}).finally(() => {
					this.progress = false;
				});
			} else {
				this.$toastr.warning("Só pode alterar projetos com situação 'Rejeitado'!");
			}
		},
		incluirProjeto() {
			location.href = '/projeto-cadastro/';
		},
		limparFiltro() {
			this.filtro = {
				ordem: 5
			}
			this.filtrarProjeto();
		},
		filtrarTipo() {
			if (this.filtroTipo === "") {
				this.listaProjeto = this.listaProjetoFiltro;
			} else {
				this.listaProjeto = this.listaProjetoFiltro.filter((item) => {
					return (
						item.nomeCodigo.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.dataInicio.indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.dataFim.indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.situacaoDescricao.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.classificacaoDescricao.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0
					);
				});
			}
		},
		carregarTela() {
			this.perfilCoordenador = (localStorage.getItem("pnome") === "COORDENADOR");
			this.perfilAdmin = (localStorage.getItem("pnome") === "ADMIN");
			this.progress = true;

			this.filtro.idPerfil = localStorage.getItem("trocaPerfil");

			this.$clubApi.post("/projeto/lista", this.filtro).then((response) => {
				this.listaProjeto = response.data.object;
				this.listaProjetoFiltro = response.data.object;
				
				this.$clubApi.get("/enum/classificacao").then((response) => {
					this.listaClassificacao = response.data.object;
				});
				this.$clubApi.get("/enum/relevancia").then((response) => {
					this.listaRelevancia = response.data.object;
				});
				this.listaInvestimento = [{ codigo: "MAIOR", descricao: "Maior igual a" }, { codigo: "MENOR", descricao: "Menor igual a" }, { codigo: "IGUAL", descricao: "Igual a" }]

				this.$clubApi.get("/atividade/tipos").then((response) => {
					this.listaTipoAtividade = response.data.object;
				});
				this.$clubApi.get("/user/responsaveis").then((response) => {
					this.listaUsuarios = response.data.object;
				});
				this.$clubApi.get("/estrutura/gt/ativoperfil/" + this.filtro.idPerfil).then((response) => {
					this.listaGT = response.data.object;
				})
			})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
		filtrarProjeto() {
			if (!this.validarPeriodosFiltro()) {
				return;
			}
			this.progress = true;
			this.$clubApi.post("/projeto/lista", this.filtro).then((response) => {
				this.listaProjeto = response.data.object;
				this.listaProjetoFiltro = response.data.object;
			})
				.catch((error) => {
					this.$toastr.error(error.response.data.msg);
				})
				.finally(() => {
					this.progress = false;
				});
		},
		abrirModalProjeto(projeto) {
			this.projetoModal = projeto;
			this.modals.modalProjeto = true;
		},
		abrirModalAtividade(atividade) {
			this.atividadeModal = atividade;
			this.modals.modalAtividade = true;
		},
		closeModalAtividade() {
			this.modals.modalAtividade = false;
		},
		closeModalProjeto() {
			this.modals.modalProjeto = false;
		},
		closeModalEdicaoProjeto() {
			this.modals.modalEdicaoProjeto = false;
			this.projetoEdicao = null;
		},
		salvarProjetoEdicao(projeto) {
			this.closeModalEdicaoProjeto();
			this.filtrarProjeto();
		},
		onChangePage(pageOfItems) {
			// update page of items
			this.pageOfItems = pageOfItems;
		},
		pesquisarProjeto() {
			if (this.filtroTipo === "") {
				this.listaProjeto = this.listaProjetoFiltro;
			} else {
				this.listaProjeto = this.listaProjetoFiltro.filter((item) => {
					return (
						item.acao.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.funcionalidade.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.usuario.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.dataHoraFmt.indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						(item.observacao != null && item.observacao.toUpperCase()
							.indexOf(this.filtroTipo.toUpperCase()) >= 0)
					);
				});
			}
		},
		alterarProjeto(projeto) {
			const options = {
				title: "Confirmação",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.$dialogs.confirm('Deseja ir para o cadastro de alteração desse projeto?', options)
				.then((res) => {
					if (res.ok) {
						location.href = '/projeto-cadastro/' + projeto.idprojeto;
					}
				});

		},
		cancelarProjeto(projeto) {
			const options = {
				title: "Confirmação",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.$dialogs.confirm('Deseja realmente cancelar esse projeto em definitivo?', options)
				.then((res) => {
					if (res.ok) {
						this.progress = true;
						let projetoRequest = {
							idprojeto: projeto.idprojeto
						}
						this.$clubApi.post("/projeto/cancelar/", projetoRequest).then(() => {
							this.filtrarProjeto();
							this.$toastr.success("Projeto cancelado com sucesso!");
						})
							.catch((error) => {
								this.$toastr.warning(error.response.data.msg);
							})
							.finally(() => {
								this.progress = false;
							});
					}
				});
		},
	}
}
</script>
<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.clickable {
	cursor: pointer;
}

.font-13 {
    font-size: 13px;
}

.filtro-contexto-ativo {
	background-color: #f2fbfc !important;
	border: 1px solid #32cbe2 !important;
}

.filtro-contexto-ativo-corpo {
	background-color: #f2fbfc !important;
	border: 1px solid #32cbe2 !important;
}

.filtro-contexto-inativo {
	background-color: #fff !important;
	border: 1px solid #b1b1b1 !important;
}

.filtro-contexto-inativo-corpo {
	background-color: #fff !important;
	border: 1px solid #b1b1b1 !important;
}

.font-reagenda {
	color: #b821bd !important;
	font-weight: 600;
}

.font-atrasado {
	color: red !important;
}

.font-CONCLUIDO {
	color: green !important;
}

.font-CANCELADO {
	color: red !important;
}
.iconeFecharModal {
	position: absolute; 
	z-index: 1; 
	width: 96%; 
	color: darkred;
}
</style>
